/*
 * Espresso variant pre-selection
 * ------------------------------------------------------------
 * When a shopper reaches a product page after coming from an
 * espresso collection, auto-select the Espresso colour variant.
 *
 * Triggers on either:
 *   - a ?collection= param containing "espresso", or
 *   - document.referrer being a /collections/ URL containing "espresso"
 *     (matches handles like "espresso" or "the-espresso-collection").
 *
 * An explicit ?variant= in the URL always wins (never overridden).
 * Loaded site-wide but is a no-op unless the conditions above match
 * AND the page has a <variant-selects> element (product pages only).
 */
(function () {
  'use strict';
  var TARGET = 'espresso';

  function cameFromEspresso() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.has('variant')) return false; // explicit variant wins
      if ((params.get('collection') || '').toLowerCase().indexOf(TARGET) !== -1) return true;
      var ref = (document.referrer || '').toLowerCase();
      return ref.indexOf('/collections/') !== -1 && ref.indexOf(TARGET) !== -1;
    } catch (e) {
      return false;
    }
  }

  // Matches an option value that starts with "espresso" (e.g. "Espresso",
  // "Espresso / 1 lb") so it works across every product in the edit.
  function isEspresso(value) {
    return (value || '').trim().toLowerCase().indexOf(TARGET) === 0;
  }

  function preselect() {
    var scope = document.querySelector('variant-selects');
    if (!scope) return false;

    var radios = scope.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (isEspresso(radios[i].value) && !radios[i].disabled) {
        if (!radios[i].checked) {
          radios[i].checked = true;
          radios[i].dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }
    }

    var selects = scope.querySelectorAll('select');
    for (var s = 0; s < selects.length; s++) {
      var opts = selects[s].options;
      for (var o = 0; o < opts.length; o++) {
        if (isEspresso(opts[o].value)) {
          if (!opts[o].selected) {
            selects[s].value = opts[o].value;
            selects[s].dispatchEvent(new Event('change', { bubbles: true }));
          }
          return true;
        }
      }
    }
    return false;
  }

  function init() {
    if (!cameFromEspresso()) return;
    if (preselect()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (preselect() || tries > 10) clearInterval(timer);
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
